import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as GROUPACTIONS } from "../../../store/actions/groupActions";
import Select from "react-select";
import cleanDeep from "clean-deep";
import GroupsRow from "./GroupsRow";
import { PlusIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import Spinner from "../../common/Spinner";
import LoadingContent from "../../common/LoadingContent";
import DeleteGroupModal from "./DeleteGroupModal";
import DatePicker from "react-datepicker";
import { DateInputFormat } from "../../common/DateComponents";
import { format } from "date-fns";
import Tooltip from "@/common/tooltip/Tooltip";

const Groups = ({ getGroups, groups, schemeOptions, groupLoading, groupUpdating, org, setOpenModal, permissions }) => {
	const [scheme, setScheme] = useState();
	const [startDate, setStartDate] = useState(() => {
		const today = new Date();
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		return new Date(firstDayOfMonth.getTime() - firstDayOfMonth.getTimezoneOffset() * 60000);
	});
	const [endDate, setEndDate] = useState(() => {
		const today = new Date();
		const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		return new Date(lastDayOfMonth.getTime() - lastDayOfMonth.getTimezoneOffset() * 60000);
	});

	const updateGroups = () => {
		getGroups(
			cleanDeep({
				scheme: scheme?.value,
				start: format(startDate, "yyyy-MM-dd"),
				end: format(endDate, "yyyy-MM-dd"),
			}),
		);
	};

	useEffect(() => {
		if (!groups?.length) updateGroups();
	}, [org]);

	if (!schemeOptions) return <LoadingContent />;

	return (
		<div className="content">
			<React.Fragment>
				{groupLoading && (
					<div className="content">
						<div className="row">
							<h5>Loading groups, hold on...</h5>
						</div>
					</div>
				)}
				{groups && (
					<React.Fragment>
						<div className="row">
							<div class="pull-left">
								<h5>Pension Groups</h5>
							</div>
							<div
								className="btn btn-success pull-right"
								onClick={setOpenModal}
								disabled={!permissions}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Add New Group</div>
							</div>
						</div>
						<div className="form-group">
							<div className="col-xs-9">
								<div className="col-xs-3 pl-0">
									<label>From</label>
									<DatePicker
										selected={startDate}
										onChange={(date) => {
											if (date && format(date, "yyyy-MM-dd") >= format(endDate, "yyyy-MM-dd")) {
												setEndDate(date);
											}
											if (date) setStartDate(date);
										}}
										wrapperClassName="full-width"
										dateFormat="dd/MM/yyyy"
										customInput={<DateInputFormat />}
									/>
									<div className="clearfix" />
								</div>
								<div className="col-xs-3 pl-0">
									<label htmlFor=" ">To</label>
									<DatePicker
										selected={endDate}
										onChange={(date) => {
											if (date && format(date, "yyyy-MM-dd") <= format(startDate, "yyyy-MM-dd")) {
												setStartDate(date);
											}
											if (date) setEndDate(date);
										}}
										wrapperClassName="full-width"
										dateFormat="dd/MM/yyyy"
										customInput={<DateInputFormat />}
									/>
									<div className="clearfix" />
								</div>
								{schemeOptions && (
									<div className="col-xs-3 pl-0">
										<label htmlFor="material-text">Scheme</label>
										<Select
											id="scheme"
											value={scheme}
											options={schemeOptions}
											onChange={setScheme}
											isClearable
										/>
										<div className="clearfix" />
									</div>
								)}
							</div>
							<div className="col-xs-3">
								<div
									id="view-group-button"
									className="btn btn-success pull-right"
									style={{
										marginTop: "27px",
									}}
									onClick={updateGroups}
								>
									{(groupUpdating && (
										<span>
											<Spinner
												style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
												className="animate-spin -ml-1 mr-3 h-5 w-5 "
											/>
											View Groups
										</span>
									)) || (
										<span>
											<MagnifyingGlassIcon
												style={{ height: "1.5em", float: "left", marginRight: 5 }}
											/>
											View Groups
										</span>
									)}
								</div>
							</div>
							<div className="clearfix" />
						</div>
					</React.Fragment>
				)}
				{groups && !groupLoading && (
					<div
						className="table-responsive"
						style={{ overflow: "auto" }}
					>
						<div
							id="active-people-table_wrapper"
							className="dataTables_wrapper no-footer"
						>
							<table
								id="active-people-table"
								className="js-table-sections table table-hover"
							>
								<thead style={{ display: "table-header-group" }}>
									<tr>
										<th width="5%"></th>
										<th>NAME</th>
										<th>SCHEME</th>
										<th>
											<span style={{ float: "left" }}>
												<Tooltip content="Employee Contribution">EE Contr.</Tooltip>
											</span>
										</th>
										<th>
											<span style={{ float: "left" }}>
												<Tooltip content="Employer Contribution">ER Contr.</Tooltip>
											</span>
										</th>
										<th>PERIOD</th>
										{/* <th>NUMBER OF EMPLOYEES</th> */}
										<th></th>
									</tr>
								</thead>
								<tbody>
									{groups.map((entry) => (
										<GroupsRow
											key={entry.id}
											group={entry}
										/>
									))}
								</tbody>
							</table>
						</div>
					</div>
				)}
				<DeleteGroupModal />
			</React.Fragment>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { groupLoading, groupUpdating } = state.pensions.group;

	const schemeOptions = state?.pensions?.scheme?.list?.map((scheme) => ({
		value: scheme.id,
		label: scheme.name,
	}));

	return {
		schemeOptions,
		groups: state?.pensions?.group?.list || [],
		groupLoading,
		groupUpdating,
		org: state?.company?.settings?.org,
		permissions: state?.permissions?.my?.permissions?.pensions != "Read",
	};
};

const mapDispatchToProps = (dispatch) => ({
	getGroups: (options) => dispatch(GROUPACTIONS.getGroups(options)),
	setOpenModal: () => dispatch(GROUPACTIONS.setOpenModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
